var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useRef } from "react";
import DateCalendar from "../Generic/DateCalendar";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import "../../stylesheets/components/Home/Home.scss";
import HomeSalesTable from "./HomeDashBoard/HomeSalesTable";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import FilterState from "./filterState";
import { EDataSource, EnumSalesFilter, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import { useLocation, useNavigate } from "react-router-dom";
import { futureMonth, getDateInFormat, getFinancialYear, TodaysDate, } from "@domains/utils/reportDates";
import moment from "moment";
import filterDI from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import { enabledHomedashboardFilters, handleDisableFilter, } from "@frameworks/salesjourney/components/constant";
import { useSelector } from "react-redux";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
var filterList = [
    {
        filter: "Lob",
        dataSource: EDataSource.LOB,
        value: EnumSalesFilter.lobId,
        inputType: "checkbox",
        //   onClick: onclick("lobId"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.lobIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Sub Lob",
        dataSource: EDataSource.SUBLOB,
        value: EnumSalesFilter.sublobId,
        inputType: "checkbox",
        //   onClick: onclick("subLobId"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.sublobIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Zone",
        dataSource: EDataSource.ZONE,
        value: EnumSalesFilter.zoneId,
        inputType: "checkbox",
        //   onClick: onclick("Zone"),
        //   disabled: false,
        alternateValue: EnumSalesFilter.zoneIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Region",
        dataSource: EDataSource.REGION,
        value: EnumSalesFilter.regionId,
        inputType: "checkbox",
        //   onClick: onclick("Region"),
        //   disabled: false,
        alternateValue: EnumSalesFilter.regionIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Branch",
        dataSource: EDataSource.BRANCH,
        value: EnumSalesFilter.branchId,
        inputType: "checkbox",
        //   onClick: onclick("Branch"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.branchIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "RM",
        dataSource: EDataSource.RM,
        value: EnumSalesFilter.rmId,
        inputType: "checkbox",
        searchBox: true,
        searchValue: "",
        alternateValue: EnumSalesFilter.rmIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Role",
        dataSource: EDataSource.ROLE,
        value: EnumSalesFilter.role,
        inputType: "checkbox",
        //   onClick: onclick(""),
        //   disabled: true,
        alternateValue: EnumSalesFilter.roleLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Type",
        dataSource: EDataSource.TYPE,
        value: EnumSalesFilter.teamType,
        inputType: "checkbox",
        alternateValue: EnumSalesFilter.teamTypeLst,
        //   onClick: onclick(""),
        //   disabled: true,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Tier",
        dataSource: EDataSource.TIER,
        value: EnumSalesFilter.clientTier,
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.clientTierLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Partners",
        value: EnumSalesFilter.partnerId,
        inputType: "checkbox",
        searchBox: true,
        searchValue: "",
        alternateValue: EnumSalesFilter.partnerIdLst,
        dropDownList: [],
        disabled: false,
    },
];
var Home = function () {
    var _a, _b, _c, _d;
    var isRHAbove = localStorage.getItem(ELocalStorageKeys.IsRHAbove);
    var _e = __read(React.useState(handleDisableFilter(filterList, enabledHomedashboardFilters)), 2), localFilterList = _e[0], setLocalFilterList = _e[1];
    var location = useLocation();
    var _f = __read(React.useState({
        fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
        toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
    }), 2), dates = _f[0], setDates = _f[1];
    var _g = __read(React.useState(true), 2), showWeek = _g[0], setShowWeek = _g[1];
    var _h = __read(React.useState(true), 2), showMonth = _h[0], setShowMonth = _h[1];
    var _j = __read(React.useState(false), 2), resetShowMonth = _j[0], setResetShowMonth = _j[1];
    var getDefaultFilters = function () {
        if (!!isRHAbove && (isRHAbove === null || isRHAbove === void 0 ? void 0 : isRHAbove.length) > 0 && isRHAbove === "Y") {
            return {
                teamType: [1, 2],
                teamTypeLst: [
                    {
                        id: leadStatusConfig.selfTeamObject.id,
                        parentFilter: EnumSalesFilter.teamType,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.teamTypeLst,
                        name: leadStatusConfig.selfTeamObject.name,
                    },
                    {
                        id: leadStatusConfig.teamTypeObject.id,
                        parentFilter: EnumSalesFilter.teamType,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.teamTypeLst,
                        name: leadStatusConfig.teamTypeObject.name,
                    },
                ],
                dataSource: EDataSource.TYPE,
            };
        }
        else {
            return {
                teamType: [1],
                teamTypeLst: [
                    {
                        id: leadStatusConfig.selfTeamObject.id,
                        parentFilter: EnumSalesFilter.teamType,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.teamTypeLst,
                        name: leadStatusConfig.selfTeamObject.name,
                    },
                ],
                dataSource: EDataSource.TYPE,
            };
        }
    };
    var oldFilterList = useSelector(function (state) { return state.Common.filterDataReducer.finalFilterState; });
    var resetfilter = (_b = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.reset) !== null && _b !== void 0 ? _b : null;
    var _k = __read(useState(oldFilterList && Object.keys(oldFilterList).length > 0 && !resetfilter
        ? oldFilterList
        : getDefaultFilters()), 2), finalFilterState = _k[0], setFinalFilterState = _k[1];
    var navigate = useNavigate();
    var homeTableRef = useRef(null);
    var onSubmit = function () {
        var _a;
        setResetShowMonth(false);
        filterDI.filter.updateFinalFilterState(finalFilterState);
        if (homeTableRef) {
            (_a = homeTableRef === null || homeTableRef === void 0 ? void 0 : homeTableRef.current) === null || _a === void 0 ? void 0 : _a.submitFilter();
        }
    };
    var getFilterDataApis = function (value, searchText, displayId, reqPayload, list) {
        if (value === EnumSalesFilter.partnerId) {
            return filterDI.filter.getPartnersListOfLoggedInFRM({
                filterData: __assign({}, list),
                page: 1,
                pageSize: 1000,
                searchText: searchText !== null && searchText !== void 0 ? searchText : "",
            });
        }
    };
    // React.useEffect(()=>{
    //   console.log("Selected Date Change", newStartDate, newEndDate)
    //   if(newStartDate && newEndDate)
    //   {
    //     homeTableRef?.current?.submitFilter();
    //   }
    // },[newStartDate,newEndDate])
    var dateChangeFilterData = function (startDate, endDate, showMonth, showWeek) {
        setFinalFilterState(function (finalFilterState) {
            var _a;
            finalFilterState.fromDate = moment(startDate).format("YYYY/MM/DD");
            finalFilterState.toDate = moment(endDate).format("YYYY/MM/DD");
            (finalFilterState.showMonth = showMonth), (finalFilterState.showWeek = showWeek);
            filterDI.filter.updateFinalFilterState(finalFilterState);
            if (homeTableRef) {
                (_a = homeTableRef === null || homeTableRef === void 0 ? void 0 : homeTableRef.current) === null || _a === void 0 ? void 0 : _a.dateChangedFilter(finalFilterState, finalFilterState.fromDate, finalFilterState.toDate);
            }
            return finalFilterState;
        });
        //  homeTableRef?.current?.submitFilter();
    };
    React.useEffect(function () {
        if (resetfilter)
            filterDI.filter.updateFinalFilterState(finalFilterState);
        return function () {
            filterList = filterList.map(function (x) {
                return __assign(__assign({}, x), { dropDownList: [] });
            });
        };
    }, []);
    var resetFunction = function () {
        var _a, _b;
        setLocalFilterList(function (localFilterList) {
            localFilterList = localFilterList.map(function (x) {
                x.dropDownList = [];
                return x;
            });
            return localFilterList;
        });
        if (!!isRHAbove && (isRHAbove === null || isRHAbove === void 0 ? void 0 : isRHAbove.length) > 0 && isRHAbove === "Y") {
            var localFinalFilterState = {
                fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
                toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
                teamType: [1, 2],
            };
            setResetShowMonth(true);
            setFinalFilterState(localFinalFilterState);
            if (homeTableRef) {
                (_a = homeTableRef === null || homeTableRef === void 0 ? void 0 : homeTableRef.current) === null || _a === void 0 ? void 0 : _a.resetFilter(localFinalFilterState);
            }
        }
        else {
            var localFinalFilterState = {
                showMonth: true,
                fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
                toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
                teamType: [1],
                teamTypeLst: [
                    {
                        id: leadStatusConfig.selfTeamObject.id,
                        parentFilter: EnumSalesFilter.teamType,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.teamTypeLst,
                        name: leadStatusConfig.selfTeamObject.name,
                    },
                ],
            };
            setResetShowMonth(true);
            filterDI.filter.updateFinalFilterState(localFinalFilterState);
            setFinalFilterState(localFinalFilterState);
            if (homeTableRef) {
                (_b = homeTableRef === null || homeTableRef === void 0 ? void 0 : homeTableRef.current) === null || _b === void 0 ? void 0 : _b.resetFilter(localFinalFilterState);
            }
        }
    };
    return (React.createElement(GridContainer, { parentClass: "home-primary-container" },
        React.createElement("div", { className: "d-flex justify-content-between align-items-center w-100" },
            React.createElement(DateCalendar, { setFinalFilterState: setFinalFilterState, monthlyFirst: Boolean((_c = oldFilterList === null || oldFilterList === void 0 ? void 0 : oldFilterList.showMonth) !== null && _c !== void 0 ? _c : true), weeklyFirst: Boolean((_d = oldFilterList === null || oldFilterList === void 0 ? void 0 : oldFilterList.showWeek) !== null && _d !== void 0 ? _d : false), resetShowMonth: resetShowMonth, todaysDate: true, setShowMonthFlag: setShowMonth, fromDate: (finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.fromDate)
                    ? finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.fromDate
                    : moment().startOf("month").format("YYYY-MM-DD"), toDate: (finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.toDate)
                    ? finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.toDate
                    : moment().endOf("month").format("YYYY-MM-DD"), ToDatemax: futureMonth(TodaysDate, 6), isMinDate: true, lastQuarter: true, lastQuarterYear: getFinancialYear(new Date()) - 1, dateChangeFilterData: dateChangeFilterData, setEndOfMonth: true, skipForFinalYear: true }),
            React.createElement(EdButton, { onClick: function () {
                    navigate("/dashboard/leadpage");
                    localStorage.setItem(ELocalStorageKeys.RefreshPage, "Y");
                }, btnTyp: "midnight-blue", value: "Create Lead", className: "p-0 create-lead text-nowrap" })),
        React.createElement("div", { className: "sales-filter-row d-flex justify-content-between w-100" },
            React.createElement(FilterState, { isSearch: false, finalFilterState: finalFilterState, setFinalFilterState: setFinalFilterState, onSubmit: onSubmit, filterList: localFilterList, showReset: true, resetFunction: resetFunction, getFilterDataApis: getFilterDataApis })),
        React.createElement(HomeSalesTable, { finalFilterState: finalFilterState, ref: homeTableRef, showWeek: false }))
    // <GridContainer parentClass="home-primary-container">
    //   <DateCalendar
    //     setFinalFilterState={setFinalFilterState}
    //     monthlyFirst={showMonth}
    //     resetShowMonth={resetShowMonth}
    //     todaysDate={true}
    //     setShowMonthFlag={setShowMonth}
    //     fromDate={moment().startOf("month").format("YYYY-MM-DD")}
    //     toDate={moment().format("YYYY-MM-DD")}
    //     ToDatemax={futureMonth(TodaysDate, 6)}
    //     isMinDate={true}
    //     lastQuarter={true}
    //     lastQuarterYear={getFinancialYear(new Date()) - 1}
    //     dateChangeFilterData={dateChangeFilterData}
    //   />
    //   <div className="sales-filter-row w-100 d-flex justify-content-between">
    //     <div>
    //       <FilterState
    //         isSearch={false}
    //         finalFilterState={finalFilterState}
    //         setFinalFilterState={setFinalFilterState}
    //         onSubmit={onSubmit}
    //         filterList={localFilterList}
    //         showReset={true}
    //         resetFunction={resetFunction}
    //       />
    //     </div>
    //     <div className="d-flex justify-content-end align-items-center">
    //       <EdButton
    //         onClick={() => {
    //           navigate("/dashboard/leadpage");
    //         }}
    //         btnTyp={"midnight-blue"}
    //         value="Create Lead"
    //         className="p-0 create-lead"
    //       />
    //     </div>
    //   </div>
    //   <HomeSalesTable
    //     finalFilterState={finalFilterState}
    //     ref={homeTableRef}
    //     showWeek={false}
    //   />
    // </GridContainer>
    );
};
export default Home;
